import {
  SET_COMPANY_SUBSCRIPTION,
  SET_COMPANY_VALID_SUBSCRIPTION,
  SET_SUBSCRIPTION,
} from "../actions/SubscriptionActions";

const initialState = {
  companySubscriptions: [],
};

const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_SUBSCRIPTION:
      return {
        ...state,
        companySubscriptions: action.payload,
      };

    case SET_COMPANY_VALID_SUBSCRIPTION:
      return {
        ...state,
        companyValidSubscriptions: action.payload,
      };

    case SET_SUBSCRIPTION:
      return {
        ...state,
        subscriptionRequest: action.payload,
      };

    default:
      return state;
  }
};

export default SubscriptionReducer;
